import './styles.scss';
import React, {useEffect} from "react";

/* types, constants, utils */
import * as Constants from "../../../../../constants";

/* bootstrap */
import {Button} from "react-bootstrap";

/* redux */
import {useSelector} from "react-redux";
import {RootState} from "../../../../../redux";
import {ISearchState} from "../../../../../types/redux/search";

/* components */
import ViewerCard from "../../../viewer-card";
import useRecordListItemSelect from "../../../hooks/useInsertDBFields";
import {IViewerState} from "../../../../../types/redux/viewer";

interface IProps {
  setNumOfRecords(value:number): void;
}

const ViewerMoreLikeList = (props: IProps):JSX.Element => {
  const {
    setNumOfRecords
  } = props;

  /* redux */
  const viewerState: IViewerState = useSelector<RootState, IViewerState>(state => state.viewer);
  const searchState: ISearchState = useSelector<RootState, ISearchState>(state => state.search);

  /* hooks*/
  const handleSelectRecord = useRecordListItemSelect().handleSelectRecord;

  const card = (result: any, index: number):JSX.Element => {
    return <Button
      key={`dc-${index}`}
      className={'viewer-card-wrapper mb-2 text-dark p-0 bg-transparent text-start w-100'}
      active={viewerState.initialRecord && viewerState.viewerRecord && (viewerState.initialRecord.id === result.id) && (viewerState.viewerRecord.id === result.id)}
      onClick={()=>handleSelectRecord(result)}
    >
      <ViewerCard
        index={index}
        record={result}
        page={1}
        resultsPerPage={Constants.VW_NUM_ROWS}
      />
    </Button>
  }

  useEffect(()=>{
    setNumOfRecords(Constants.MORE_LIKE_ROWS)
  }, [setNumOfRecords])

  const moreLikeThis = (): any[] => {
    let moreLikeThis:string[] = [];
    if (viewerState.initialRecord.moreLikeThis &&
      viewerState.initialRecord.moreLikeThis[viewerState.initialRecord.id] &&
      viewerState.initialRecord.moreLikeThis[viewerState.initialRecord.id].docs
    ) {
      if (searchState.industry === Constants.ALL_INDUSTRIES) {
        moreLikeThis = viewerState.initialRecord.moreLikeThis[viewerState.initialRecord.id].docs;
      } else {
        /* industries specific documents */
        const docs: any[] = viewerState.initialRecord.moreLikeThis[viewerState.initialRecord.id].docs;
        for (let i = 0; i < docs.length; i++) {
          if (docs[i].industrycode.toLowerCase() === searchState.industry.toLowerCase()) {
            moreLikeThis.push(docs[i])
          }
        }
      }
    }

    return moreLikeThis
  }

  return (
    <div className={'viewer-more-like-list overflow-scroll pt-2'}>
      <div className={'cards d-flex flex-column pb-2'} >
        {card(viewerState.initialRecord, -1)}

        {viewerState.initialRecord && moreLikeThis().map((result: any, index: number) => {
          return card(result, index)
        })}
      </div>
    </div>
  )
}
export default ViewerMoreLikeList;
